export const normalizeSelectKey = (value = '') =>
  String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();

export const OPERACIONES_OPTIONS = [
  'Por Atender',
  'Andre Sandoval',
  'Diego Catter',
  'Sandy Hernandez',
  'Unifye',
  'Deudafix',
  'Reparadora',
  'No Viable',
];

export const COMERCIAL_OPTIONS = [
  'No Asignado',
  'No Contesta',
  'Andre Sandoval',
  'Francesco La Rosa',
  'Alamo Cusihuaman',
  'Yeniffer Quevedo',
  // Equipo comercial incorporado el 25/08
  'Jasmin Suarez',
  'Carina Hernández',
  'Andrea Sánchez',
  'Cristian Vicent',
  'Linda Montoya',
  'Alexandra Gomez',
  'Gabriela Lume',
  'Joaquin Uribe',
  'Andrea Leyva',
];

// Manual assignment lists only. Automatic lead distribution has its own roster.
export const COMERCIAL_PEOPLE = COMERCIAL_OPTIONS.filter(
  (name) => !['No Asignado', 'No Contesta'].includes(name)
);

export const AGENT_FIELD_CONFIG = {
  operacionesAgent: {
    defaultValue: 'Por Atender',
    options: OPERACIONES_OPTIONS,
    aliases: {
      '': 'Por Atender',
      'por atender': 'Por Atender',
      'no contesta': 'Por Atender',
      'andre': 'Andre Sandoval',
      'andre sandoval': 'Andre Sandoval',
      'diego': 'Diego Catter',
      'diego catter': 'Diego Catter',
      'sandy': 'Sandy Hernandez',
      'sandy hernandez': 'Sandy Hernandez',
      'unifye': 'Unifye',
      'deudafix': 'Deudafix',
      'reparadora': 'Reparadora',
      'no viable': 'No Viable',
      'no viable edad': 'No Viable',
    },
  },
  comercialAgent: {
    defaultValue: 'No Asignado',
    options: COMERCIAL_OPTIONS,
    aliases: {
      '': 'No Asignado',
      'no asignado': 'No Asignado',
      'no contesta': 'No Contesta',
      'andre': 'Andre Sandoval',
      'andre sandoval': 'Andre Sandoval',
      'francesco': 'Francesco La Rosa',
      'francesco la rosa': 'Francesco La Rosa',
      'alamo': 'Alamo Cusihuaman',
      'alamo cusihuaman': 'Alamo Cusihuaman',
      // Jonathan ya no se puede asignar, pero su valor histórico se conserva.
      'jonathan': 'Jonathan',
      'yeniffer': 'Yeniffer Quevedo',
      'yeniffer quevedo': 'Yeniffer Quevedo',
      // Valores retirados: se mantienen al leer históricos, pero no aparecen
      // en las opciones de nuevas asignaciones.
      'jefferson merino': 'Jefferson Merino',
      'suyin': 'Suyin Rodríguez',
      'suyin rodriguez': 'Suyin Rodríguez',
      'fernando': 'Fernando Rondón',
      'fernando rondon': 'Fernando Rondón',
      'alba perez': 'Alba Pérez',
      'kimberlin rincon': 'Kimberlin Rincon',
      'genesis paredes': 'Génesis Paredes',
      'kiara': 'No Asignado',
    },
  },
};

export const normalizeAgentValue = (field, value) => {
  const config = AGENT_FIELD_CONFIG[field];

  if (!config) {
    return value || '';
  }

  const normalizedKey = normalizeSelectKey(value);
  const configuredOption = config.options.find(
    (option) => normalizeSelectKey(option) === normalizedKey
  );
  return config.aliases[normalizedKey] || configuredOption || config.defaultValue;
};

// Un valor histórico retirado (hoy, Jonathan) se muestra únicamente en los
// registros que ya lo tenían. No vuelve a aparecer como opción de asignación.
export const agentOptionsForValue = (field, value) => {
  const config = AGENT_FIELD_CONFIG[field];
  if (!config) return [];
  const normalizedValue = normalizeAgentValue(field, value);
  return config.options.includes(normalizedValue)
    ? config.options
    : [...config.options, normalizedValue];
};
